import React from "react";
import "./style.scss";

const ButtomAmount = props => {
  const { amount, className } = props;
  return (
    <button {...props} type="button" className={`btn btn-outline-info ${className ? className : ""}`} data-amount={amount}>
      {`R$${amount}`}
    </button>
  );
};

ButtomAmount.defaultProps = {
  amount: 20
};

export default ButtomAmount;
